/* Strap finder — extracted from sections/strap-finder.liquid (Sep 2026).

   It was 35KB of inline script repeated in the HTML of every product page and
   of the strap-finder collection page. Nothing in it was Liquid-driven except
   the section id, which each root already carries as `data-section-id`, so it
   moves out wholesale and is now fetched once and cached.

   All tunable copy and endpoints still come from the section's
   `data-sf-config` JSON block, which stays inline. */
(function () {
  function init(SECTION_ID) {
    var root = document.querySelector('[data-strap-finder][data-section-id="' + SECTION_ID + '"]');
    if (!root || root.getAttribute('data-init') === 'true') return;
    root.setAttribute('data-init', 'true');

    var MIN_CHARS = 2;
    var PAGE_SIZE = 12;      // watch results shown per "page" in the dropdown
    var FETCH_LIMIT = 100;
    var DEBOUNCE_MS = 250;
    var RESULT_CAP = 12;        // the search worker never returns more than this
    // A second token matches the START of a model name ("omega r" -> Railmaster),
    // so re-running the query per letter is the only way to see past that cap.
    // These 11 were measured across the eight largest brands in the database:
    // they surface 90% of what a full a-z sweep finds, for 11 requests not 26.
    var WIDEN_SUFFIXES = ['b', 'g', 'a', 'c', 'd', 'i', 'p', 'r', 'e', 'm', 's'];
    var WIDEN_DELAY_MS = 350;

    function $(sel, ctx) { return (ctx || root).querySelector(sel); }
    function safeParse(s) { try { return JSON.parse(s); } catch (e) { return null; } }
    function clearChildren(el) { if (!el) return; while (el.firstChild) el.removeChild(el.firstChild); }
    function setVisible(el, show) { if (!el) return; if (show) el.removeAttribute('hidden'); else el.setAttribute('hidden', 'hidden'); }

    var cfgEl = $('[data-sf-config]');
    var cfg = (cfgEl && safeParse(cfgEl.textContent)) || {};
    if (!cfg.collection) return;

    var input = $('[data-sf-search]');
    var clearBtn = $('[data-sf-clear]');
    var resultsEl = $('[data-sf-results]');
    var selectionEl = $('[data-sf-selection]');
    var selectionName = $('[data-sf-selection-name]');
    var selectionLug = $('[data-sf-selection-lug]');
    var changeBtn = $('[data-sf-change]');
    var pickerEl = $('[data-sf-picker]');
    var headEl = $('[data-sf-results-head]');
    var countEl = $('[data-sf-count]');
    var shopAllEl = $('[data-sf-shop-all]');
    var statusEl = $('[data-sf-status]');
    var gridEl = $('[data-sf-grid]');
    var moreEl = $('[data-sf-more]');
    var moreBtn = $('[data-sf-more-btn]');
    if (!input || !resultsEl || !gridEl) return;

    /* ---------------- shared watch storage (same key as the PDP checker) --------------- */

    function loadSaved() { try { return safeParse(localStorage.getItem(cfg.storageKey)); } catch (e) { return null; } }
    function save(d) {
      try { localStorage.setItem(cfg.storageKey, JSON.stringify(d)); } catch (e) {}
      // Same signal the PDP checker sends, so a watch chosen here marks the
      // Lug Width dropdown on any product page opened afterwards.
      try { document.dispatchEvent(new CustomEvent('mgb:watch-fit-change', { detail: d })); } catch (e) {}
    }

    /* ---------------- watch search (Cloudflare Worker) --------------- */

    function getReference(item) {
      var r = (item && (item.reference != null ? item.reference : (item.ref != null ? item.ref : (item.Reference != null ? item.Reference : item.watch_reference))));
      return (r === null || r === undefined) ? '' : String(r).trim();
    }
    function getLugWidth(item) {
      var lw = null;
      if (item) {
        if (item.lugWidth != null) lw = item.lugWidth;
        else if (item.lug_width != null) lw = item.lug_width;
        else if (item.lug_width_mm != null) lw = item.lug_width_mm;
        else if (item.lugWidthMm != null) lw = item.lugWidthMm;
      }
      if (lw === null || lw === undefined) return '';
      return String(lw).replace(/mm/i, '').trim();
    }
    function normaliseLug(lw) {
      var s = String(lw == null ? '' : lw).replace(/mm/i, '').trim();
      if (!s) return '';
      var n = parseFloat(s);
      if (isNaN(n)) return s;
      // 20 -> "20", 20.0 -> "20", 19.5 -> "19.5"
      return String(n % 1 === 0 ? n.toFixed(0) : n);
    }
    function normaliseFromApi(item) {
      if (!item || typeof item !== 'object') return null;
      var reference = getReference(item) || String(item.unique_id || item.uniqueId || '').trim();
      if (!reference) return null;
      return {
        brand: String(item.brand || '').trim(),
        model: String(item.model || '').trim(),
        reference: reference,
        uniqueId: String(item.unique_id || item.uniqueId || '').trim(),
        lugWidth: normaliseLug(getLugWidth(item))
      };
    }
    function extractResults(json) {
      if (!json) return [];
      if (Array.isArray(json)) return json;
      if (Array.isArray(json.results)) return json.results;
      if (json.results && Array.isArray(json.results.items)) return json.results.items;
      if (Array.isArray(json.items)) return json.items;
      if (Array.isArray(json.data)) return json.data;
      if (json.data && Array.isArray(json.data.results)) return json.data.results;
      return [];
    }
    function formatSelection(sel) {
      if (!sel) return '';
      var b = String(sel.brand || '').trim();
      var m = String(sel.model || '').trim();
      var r = String(sel.reference || '').trim();
      if (b && m && r) return b + ' ' + m + ' – ' + r;
      if (r) return r;
      if (b && m) return b + ' ' + m;
      return b || m || '';
    }

    /* ---------------- typo tolerance ---------------
       The search worker matches on plain substrings, so one wrong letter
       ("rolex subs") returns nothing. When a query comes back empty we
       re-ask with progressively shorter prefixes of the last word, then
       rank whatever comes back against what the customer actually typed. */

    function normText(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
    function tokenize(s) {
      return normText(s).split(' ').filter(function (t) { return t.length > 0; });
    }
    function levenshtein(a, b) {
      if (a === b) return 0;
      var al = a.length, bl = b.length;
      if (!al) return bl;
      if (!bl) return al;
      var prev = new Array(bl + 1), cur = new Array(bl + 1), i, j;
      for (j = 0; j <= bl; j++) prev[j] = j;
      for (i = 1; i <= al; i++) {
        cur[0] = i;
        for (j = 1; j <= bl; j++) {
          var cost = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
          cur[j] = Math.min(cur[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
        }
        for (j = 0; j <= bl; j++) prev[j] = cur[j];
      }
      return prev[bl];
    }
    function maxDist(len) { return len <= 3 ? 0 : (len <= 6 ? 1 : 2); }
    function tokenScore(t, w) {
      if (!t || !w) return 0;
      if (w === t) return 1;
      if (w.indexOf(t) === 0) return 0.95;
      if (w.indexOf(t) > -1) return 0.85;
      var m = maxDist(t.length);
      if (!m) return 0;
      // Compare against the same-length head of the word so a typo late in a
      // long name still matches: "subs" vs "subm" is one edit, not seven.
      var d = levenshtein(t, w.slice(0, t.length));
      if (d <= m) return 0.8 - 0.1 * d;
      d = levenshtein(t, w);
      if (d <= m) return 0.75 - 0.1 * d;
      return 0;
    }
    function itemScore(raw, tokens) {
      var item = normaliseFromApi(raw);
      if (!item) return 0;
      var words = tokenize([item.brand, item.model, item.reference].join(' '));
      if (!words.length) return 0;
      var total = 0;
      for (var i = 0; i < tokens.length; i++) {
        var best = 0;
        for (var j = 0; j < words.length; j++) {
          var s = tokenScore(tokens[i], words[j]);
          if (s > best) best = s;
          if (best === 1) break;
        }
        if (!best) return 0; // every word the customer typed must match something
        total += best;
      }
      return total / tokens.length;
    }
    function rankItems(items, tokens) {
      return items
        .map(function (raw) { return { raw: raw, score: itemScore(raw, tokens) }; })
        .filter(function (x) { return x.score >= 0.5; })
        .sort(function (a, b) { return b.score - a.score; })
        .map(function (x) { return x.raw; });
    }
    function fallbackQueries(q) {
      var toks = tokenize(q);
      if (!toks.length) return [];
      var head = toks.slice(0, -1);
      var last = toks[toks.length - 1];
      var full = toks.join(' ');
      var byLength = toks.slice().sort(function (a, b) { return b.length - a.length; });
      var out = [];
      function add(s) {
        s = String(s || '').trim();
        if (s.length >= MIN_CHARS && s !== full && out.indexOf(s) === -1) out.push(s);
      }
      // 1. Drop the last letter — the commonest typo while typing.
      if (last.length > 2) add(head.concat(last.slice(0, -1)).join(' '));
      // 2. Each word on its own, longest first — catches a typo in any
      //    other word ("omga seamaster" still finds Seamaster).
      byLength.forEach(add);
      // 3. Shorter and shorter prefixes of the longest word, for a typo
      //    buried in the middle of it ("submarner" -> "submar").
      var longest = byLength[0];
      for (var k = 2; k <= 4; k++) {
        if (longest.length - k < 3) break;
        add(longest.slice(0, longest.length - k));
      }
      // 4. Everything except the last word.
      add(head.join(' '));
      return out.slice(0, 6);
    }

    function apiSearchPlain(qRaw) {
      var q = String(qRaw || '').trim();
      if (q.length < MIN_CHARS || !cfg.endpoint) return Promise.resolve([]);
      return fetch(cfg.endpoint + '?q=' + encodeURIComponent(q) + '&limit=' + FETCH_LIMIT,
                   { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (json) { return extractResults(json); })
        .catch(function () { return []; });
    }

    function itemKey(raw) {
      var item = normaliseFromApi(raw);
      return item ? (normText(item.brand) + '|' + normText(item.model) + '|' + normText(item.reference)) : '';
    }

    // The worker truncates at RESULT_CAP with no paging, so a brand search
    // returns one model over and over. When we hit the cap, fan out and merge.
    function widen(q, items, seq, onMerged) {
      if (!items || items.length < RESULT_CAP) return;
      var merged = items.slice();
      var seen = {};
      merged.forEach(function (x) { var k = itemKey(x); if (k) seen[k] = 1; });
      // Wait for the customer to stop typing before fanning out, so a widen
      // runs once per finished query rather than once per keystroke.
      setTimeout(function () {
        if (seq !== searchSeq) return;
        fanOut();
      }, WIDEN_DELAY_MS);

      function fanOut() {
      Promise.all(WIDEN_SUFFIXES.map(function (suffix) {
        return apiSearchPlain(q + ' ' + suffix);
      })).then(function (batches) {
        if (seq !== searchSeq) return;
        var added = 0;
        batches.forEach(function (batch) {
          (batch || []).forEach(function (raw) {
            var k = itemKey(raw);
            if (!k || seen[k]) return;
            seen[k] = 1;
            merged.push(raw);
            added++;
          });
        });
        if (added) onMerged(merged);
      });
      }
    }

    var activeController = null;
    function apiSearch(qRaw) {
      var q = String(qRaw || '').trim();
      if (q.length < MIN_CHARS) return Promise.resolve({ items: [], error: null });
      if (!cfg.endpoint) return Promise.resolve({ items: [], error: { message: 'Missing endpoint' } });
      if (activeController && typeof activeController.abort === 'function') {
        try { activeController.abort(); } catch (e) {}
      }
      activeController = (window.AbortController ? new AbortController() : null);
      var url = cfg.endpoint + '?q=' + encodeURIComponent(q) + '&limit=' + FETCH_LIMIT;
      var opts = { headers: { 'Accept': 'application/json' } };
      if (activeController) opts.signal = activeController.signal;
      return fetch(url, opts).then(function (res) {
        var ok = res.ok, status = res.status;
        return res.text().then(function (txt) {
          var json = safeParse(txt);
          if (!ok) return { items: [], error: { status: status, message: 'HTTP ' + status } };
          if (!json) return { items: [], error: { message: 'Invalid JSON' } };
          return { items: extractResults(json), error: null };
        });
      }).catch(function (e) {
        if (e && e.name === 'AbortError') return { items: [], error: null, aborted: true };
        return { items: [], error: { message: (e && e.message) ? e.message : 'Network error' } };
      });
    }

    /* ---------------- dropdown --------------- */

    var allGroups = [];
    var currentPage = 0;
    var approxNote = '';

    function openResults() { setVisible(resultsEl, true); input.setAttribute('aria-expanded', 'true'); }
    function hideResults() { clearChildren(resultsEl); setVisible(resultsEl, false); input.setAttribute('aria-expanded', 'false'); }

    function renderInfoRow(text) {
      clearChildren(resultsEl);
      var li = document.createElement('li');
      li.className = 'mgb-sf__result';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mgb-sf__result-btn';
      btn.disabled = true;
      btn.textContent = text;
      li.appendChild(btn);
      resultsEl.appendChild(li);
      openResults();
    }

    // One row per brand + model. Grouping by lug width as well used to split
    // a single model into three near-identical rows, which read as "we only
    // stock Constellations".
    function groupResults(items) {
      var groups = {}, order = [];
      (items || []).forEach(function (raw) {
        var item = normaliseFromApi(raw);
        if (!item || !item.reference) return;
        var key = normText(item.brand) + '||' + normText(item.model);
        if (!groups[key]) {
          groups[key] = { brand: item.brand, model: item.model, refs: [], seen: {} };
          order.push(key);
        }
        var g = groups[key];
        if (g.seen[item.reference]) return;
        g.seen[item.reference] = 1;
        g.refs.push({ reference: item.reference, lugWidth: item.lugWidth, uniqueId: item.uniqueId });
      });
      return order.map(function (k) {
        var g = groups[k];
        var lugs = [];
        g.refs.forEach(function (r) {
          if (r.lugWidth && lugs.indexOf(r.lugWidth) === -1) lugs.push(r.lugWidth);
        });
        lugs.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
        g.lugs = lugs;
        return g;
      });
    }

    function lugSummary(lugs) {
      if (!lugs.length) return '';
      if (lugs.length === 1) return lugs[0] + 'mm';
      if (lugs.length <= 3) return lugs.join(', ') + 'mm';
      return lugs[0] + '–' + lugs[lugs.length - 1] + 'mm';
    }

    function renderGroup(group) {
      var li = document.createElement('li');
      li.className = 'mgb-sf__result';
      li.setAttribute('role', 'option');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mgb-sf__result-btn';

      var name = document.createElement('span');
      name.className = 'mgb-sf__name';
      if (group.brand) {
        var b = document.createElement('span');
        b.className = 'mgb-sf__brand';
        b.textContent = group.brand;
        name.appendChild(b);
      }
      var m = document.createElement('span');
      m.className = 'mgb-sf__model';
      m.textContent = group.model || (group.refs[0] && group.refs[0].reference) || '';
      name.appendChild(m);
      if (group.refs.length === 1) {
        var refEl = document.createElement('span');
        refEl.className = 'mgb-sf__ref';
        refEl.textContent = 'Ref: ' + group.refs[0].reference;
        name.appendChild(refEl);
      } else {
        var refCount = document.createElement('span');
        refCount.className = 'mgb-sf__ref-count';
        refCount.textContent = group.refs.length + ' references — choose one';
        name.appendChild(refCount);
      }
      btn.appendChild(name);

      if (group.lugs.length) {
        var lug = document.createElement('span');
        lug.className = 'mgb-sf__lug';
        lug.appendChild(document.createTextNode(group.lugs.length > 1 ? 'Lug widths' : 'Lug width'));
        var strong = document.createElement('strong');
        strong.textContent = lugSummary(group.lugs);
        lug.appendChild(strong);
        btn.appendChild(lug);
      }

      if (group.refs.length === 1) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          selectFit(group, group.refs[0]);
        });
        li.appendChild(btn);
      } else {
        var caret = document.createElement('span');
        caret.className = 'mgb-sf__caret';
        caret.setAttribute('aria-hidden', 'true');
        caret.textContent = '▾';
        btn.appendChild(caret);

        var refList = document.createElement('ul');
        refList.className = 'mgb-sf__ref-list';
        refList.hidden = true;
        refList.setAttribute('role', 'listbox');
        group.refs.forEach(function (ref) {
          var refLi = document.createElement('li');
          refLi.className = 'mgb-sf__ref-item';
          refLi.setAttribute('role', 'option');
          var refBtn = document.createElement('button');
          refBtn.type = 'button';
          refBtn.className = 'mgb-sf__ref-item-btn';
          refBtn.textContent = ref.reference + (ref.lugWidth ? ' · ' + ref.lugWidth + 'mm' : '');
          refBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            selectFit(group, ref);
          });
          refLi.appendChild(refBtn);
          refList.appendChild(refLi);
        });

        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          refList.hidden = expanded;
          caret.classList.toggle('is-open', !expanded);
        });
        li.appendChild(btn);
        li.appendChild(refList);
      }
      resultsEl.appendChild(li);
    }

    function renderNext() {
      var li = document.createElement('li');
      li.className = 'mgb-sf__result';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mgb-sf__next-btn';
      var remaining = allGroups.length - (currentPage + 1) * PAGE_SIZE;
      var nextCount = Math.min(remaining, PAGE_SIZE);
      btn.textContent = 'Next ' + nextCount + (nextCount === 1 ? ' watch' : ' watches');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        currentPage++;
        renderDropdownPage();
      });
      li.appendChild(btn);
      resultsEl.appendChild(li);
    }

    function renderNotice(text) {
      var li = document.createElement('li');
      li.className = 'mgb-sf__result';
      var note = document.createElement('p');
      note.className = 'mgb-sf__notice';
      note.textContent = text;
      li.appendChild(note);
      resultsEl.appendChild(li);
    }

    function renderDropdownPage() {
      clearChildren(resultsEl);
      if (approxNote && currentPage === 0) renderNotice(approxNote);
      var start = currentPage * PAGE_SIZE;
      var end = Math.min(start + PAGE_SIZE, allGroups.length);
      for (var i = start; i < end; i++) renderGroup(allGroups[i]);
      if (end < allGroups.length) renderNext();
      openResults();
    }

    function showResults(items, note) {
      allGroups = groupResults(items);
      currentPage = 0;
      approxNote = note || '';
      if (!allGroups.length) { renderInfoRow('No matches found.'); return; }
      renderDropdownPage();
    }

    var timer = null;
    function debounce(fn, wait) {
      return function () {
        var args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () { fn.apply(null, args); }, wait);
      };
    }

    var searchSeq = 0;

    function runFallback(q, seq) {
      var queries = fallbackQueries(q);
      var tokens = tokenize(q);
      function step(i) {
        if (seq !== searchSeq) return;
        if (i >= queries.length) {
          allGroups = [];
          currentPage = 0;
          approxNote = '';
          renderInfoRow('No match for “' + q + '”. Try fewer letters, or search your reference number.');
          return;
        }
        return apiSearch(queries[i]).then(function (res) {
          if (seq !== searchSeq || (res && res.aborted)) return;
          var items = (res && res.items) ? res.items : [];
          // Keep going unless something genuinely resembles what was typed —
          // offering the wrong watch would hand the customer the wrong strap.
          var ranked = items.length ? rankItems(items, tokens) : [];
          if (!ranked.length) return step(i + 1);
          var note = 'No exact match for “' + q + '” — closest matches:';
          showResults(ranked, note);
          widen(queries[i], items, seq, function (merged) {
            if (seq !== searchSeq) return;
            var reranked = rankItems(merged, tokens);
            if (reranked.length) showResults(reranked, note);
          });
        });
      }
      return step(0);
    }

    function handleSearch() {
      var q = (input.value || '').trim();
      setVisible(clearBtn, q.length > 0);
      if (q.length < MIN_CHARS) { hideResults(); return; }
      var seq = ++searchSeq;
      renderInfoRow('Searching…');
      apiSearch(q).then(function (res) {
        if (seq !== searchSeq || res.aborted) return;
        if (res.error) { renderInfoRow('Search error. Try again.'); return; }
        if (res.items.length) {
          showResults(res.items);
          widen(q, res.items, seq, function (merged) {
            if (seq === searchSeq) showResults(merged);
          });
          return;
        }
        return runFallback(q, seq);
      });
    }

    /* ---------------- selection + grid --------------- */

    var selected = null;
    var gridMode = 'initial';   // 'initial' = the collection's own top products
    var gridLug = '';
    var gridPage = 1;
    var gridPages = 1;
    var serverCount = 0;
    var hiddenByFit = 0;
    var shownCount = 0;
    var gridRequest = 0;
    var initialFallbackUsed = false;

    function filterParam(lug) {
      return 'filter.v.option.' + encodeURIComponent(cfg.optionName) + '=' + encodeURIComponent(lug + 'mm');
    }
    function collectionUrl(lug) {
      return '/collections/' + encodeURIComponent(cfg.collection) + '?' + filterParam(lug);
    }
    function initialCollection() {
      return (initialFallbackUsed ? '' : cfg.initialCollection) || cfg.collection;
    }
    function gridUrl(page) {
      var handle = gridMode === 'fit' ? cfg.collection : initialCollection();
      var params = ['view=' + encodeURIComponent(cfg.view)];
      if (gridMode === 'fit') {
        params.push(filterParam(gridLug));
        // Merchandising order only applies to the pre-search view; fitment
        // results use the section's chosen sort.
        if (cfg.sortBy) params.push('sort_by=' + encodeURIComponent(cfg.sortBy));
      }
      if (page > 1) params.push('page=' + page);
      return '/collections/' + encodeURIComponent(handle) + '?' + params.join('&');
    }

    function setStatus(text, isError) {
      if (!statusEl) return;
      statusEl.classList.toggle('is-error', !!isError);
      statusEl.textContent = text || '';
      setVisible(statusEl, !!text);
    }

    function fitsSelectedWatch(li) {
      if (gridMode !== 'fit' || !selected) return true;
      if (!li || li.getAttribute('data-curved') !== 'true') return true;
      var ids = safeParse(li.getAttribute('data-curved-ids') || '[]');
      if (!Array.isArray(ids) || !ids.length) return false;
      var wanted = [];
      if (selected.reference) wanted.push(String(selected.reference).trim());
      if (selected.uniqueId) wanted.push(String(selected.uniqueId).trim());
      for (var i = 0; i < ids.length; i++) {
        if (wanted.indexOf(String(ids[i]).trim()) > -1) return true;
      }
      return false;
    }

    // Deep-link each card to the variant in the customer's lug width so the
    // PDP opens on the right size. Shopify already appends ?variant= to some
    // filtered product URLs, so set the param rather than appending it.
    function applyVariantLinks(li, lug) {
      if (!lug) return;
      var map = safeParse(li.getAttribute('data-lug-variants') || '{}');
      if (!map) return;
      var variantId = map[lug + 'mm'];
      if (!variantId) return;
      var basePath = (li.getAttribute('data-product-url') || '').split('?')[0];
      if (!basePath) return;
      li.querySelectorAll('a[href]').forEach(function (a) {
        var raw = a.getAttribute('href') || '';
        if (raw.split('?')[0] !== basePath) return;
        var u = new URL(raw, window.location.origin);
        u.searchParams.set('variant', variantId);
        a.setAttribute('href', u.pathname + u.search);
      });
    }

    function updateCount() {
      if (!countEl) return;
      if (gridMode !== 'fit') {
        if (!shownCount || !cfg.initialHeading) { setVisible(headEl, false); return; }
        countEl.textContent = cfg.initialHeading;
        setVisible(headEl, true);
        return;
      }
      var total = Math.max(serverCount - hiddenByFit, shownCount);
      if (!total) { setVisible(headEl, false); return; }
      var label = total === 1 ? cfg.countSingular : cfg.countPlural;
      countEl.textContent = total + ' ' + label + ' ' + formatSelection(selected);
      setVisible(headEl, true);
    }

    function renderGridPage(html, append) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var payload = doc.querySelector('[data-strap-finder-payload]');
      if (payload) {
        serverCount = append ? serverCount : parseInt(payload.getAttribute('data-count'), 10) || 0;
        gridPage = parseInt(payload.getAttribute('data-page'), 10) || 1;
        gridPages = parseInt(payload.getAttribute('data-pages'), 10) || 1;
      }
      var items = doc.querySelectorAll('[data-strap-finder-card]');
      if (!append) { clearChildren(gridEl); hiddenByFit = 0; shownCount = 0; }

      Array.prototype.forEach.call(items, function (li) {
        if (!fitsSelectedWatch(li)) { hiddenByFit++; return; }
        applyVariantLinks(li, gridMode === 'fit' ? gridLug : '');
        gridEl.appendChild(document.importNode(li, true));
        shownCount++;
      });

      setVisible(gridEl, shownCount > 0);
      setVisible(moreEl, gridPage < gridPages);
      if (!shownCount && gridPage >= gridPages) {
        setStatus(gridMode === 'fit' ? cfg.noResultsText : '', false);
      } else {
        setStatus('', false);
      }
      updateCount();
    }

    function loadGrid(page, append) {
      var token = ++gridRequest;
      gridEl.classList.add('is-loading');
      if (!append) {
        if (gridMode === 'fit') setStatus('Finding straps that fit…', false);
        setVisible(moreEl, false);
      } else if (moreBtn) {
        moreBtn.disabled = true;
      }
      return fetch(gridUrl(page), { headers: { 'Accept': 'text/html' } })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          if (token !== gridRequest) return;
          renderGridPage(html, append);
          // An empty or unset landing collection falls back to the collection
          // the finder searches, so the page is never blank on arrival.
          if (gridMode === 'initial' && !shownCount && !append && !initialFallbackUsed
              && initialCollection() !== cfg.collection) {
            initialFallbackUsed = true;
            return loadGrid(1, false);
          }
        })
        .catch(function () {
          if (token !== gridRequest) return;
          if (gridMode === 'fit') setStatus('We could not load the straps just now. Please try again.', true);
        })
        .then(function () {
          if (token !== gridRequest) return;
          gridEl.classList.remove('is-loading');
          if (moreBtn) moreBtn.disabled = false;
        });
    }

    function showInitialGrid() {
      if (!cfg.showInitial) {
        gridMode = 'initial';
        clearChildren(gridEl);
        setVisible(gridEl, false);
        setVisible(headEl, false);
        setVisible(moreEl, false);
        setStatus(cfg.emptyText, false);
        return;
      }
      gridMode = 'initial';
      gridLug = '';
      gridPage = 1;
      setStatus('', false);
      loadGrid(1, false);
    }

    function renderShopAll(lug) {
      if (!shopAllEl) return;
      if (!cfg.showShopAll || !lug) { setVisible(shopAllEl, false); return; }
      shopAllEl.href = collectionUrl(lug);
      shopAllEl.textContent = 'Browse all ' + lug + 'mm straps →';
      setVisible(shopAllEl, true);
    }

    function showSelection(sel) {
      selected = sel;
      setVisible(pickerEl, false);
      setVisible(selectionEl, true);
      if (selectionName) selectionName.textContent = formatSelection(sel);
      if (selectionLug) selectionLug.textContent = sel.lugWidth ? sel.lugWidth + 'mm lug width' : '';
      hideResults();
    }

    function showPicker() {
      setVisible(pickerEl, true);
      setVisible(selectionEl, false);
      if (shopAllEl) setVisible(shopAllEl, false);
      selected = null;
      input.value = '';
      setVisible(clearBtn, false);
      showInitialGrid();
      input.focus();
    }

    function applySelection(sel, persist) {
      if (!sel || !sel.lugWidth) {
        setStatus('We do not have a lug width on record for that watch yet.', true);
        return;
      }
      if (persist) save({ brand: sel.brand, model: sel.model, reference: sel.reference, lugWidth: sel.lugWidth });
      showSelection(sel);
      renderShopAll(sel.lugWidth);
      gridMode = 'fit';
      gridLug = sel.lugWidth;
      gridPage = 1;
      loadGrid(1, false);
    }

    function selectFit(group, ref) {
      if (!ref) return;
      applySelection({
        brand: group.brand,
        model: group.model,
        reference: ref.reference,
        uniqueId: ref.uniqueId || '',
        lugWidth: normaliseLug(ref.lugWidth)
      }, true);
    }

    /* ---------------- wiring --------------- */

    input.addEventListener('input', debounce(handleSearch, DEBOUNCE_MS));
    input.addEventListener('focus', function () {
      if ((input.value || '').trim().length >= MIN_CHARS && allGroups.length) renderDropdownPage();
    });
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        setVisible(clearBtn, false);
        hideResults();
        input.focus();
      });
    }
    if (changeBtn) changeBtn.addEventListener('click', showPicker);
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        if (gridPage >= gridPages) return;
        if (gridMode === 'fit' && !selected) return;
        loadGrid(gridPage + 1, true);
      });
    }
    document.addEventListener('click', function (e) {
      if (!pickerEl.contains(e.target)) hideResults();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hideResults();
    });

    // Pick up a watch already chosen on a product page.
    //
    // Deferred until the section is actually approached (page-weight audit
    // 2026-09-17). Either branch below ends in loadGrid(), which fetches
    // /collections/<handle>?view=strap-finder-grid and renders a product card
    // -- a 533px image plus a 200px swatch per colour -- for every strap in the
    // collection. On a product page this section sits ~4,400px down, so that was
    // several MB of grid images pulled on every PDP view before anyone had
    // scrolled near it. IntersectionObserver with a 600px margin keeps the grid
    // ready before it scrolls into view while costing nothing to shoppers who
    // never reach it. Behaviour once visible is unchanged.
    function startGrid() {
      var saved = loadSaved();
      if (saved && normaliseLug(saved.lugWidth)) {
        applySelection({
          brand: saved.brand,
          model: saved.model,
          reference: saved.reference,
          uniqueId: saved.uniqueId || saved.reference,
          lugWidth: normaliseLug(saved.lugWidth)
        }, false);
      } else {
        showInitialGrid();
      }
    }

    if (!('IntersectionObserver' in window)) {
      startGrid();
    } else {
      var started = false;
      var io = new IntersectionObserver(function (entries) {
        if (started) return;
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          started = true;
          io.disconnect();
          startGrid();
          return;
        }
      }, { rootMargin: '600px 0px' });
      io.observe(root);
      // A shopper who types a watch or opens the picker before scrolling still
      // needs the grid, so any interaction with the finder starts it early.
      ['focus', 'input', 'click'].forEach(function (evt) {
        root.addEventListener(evt, function once() {
          if (started) return;
          started = true;
          io.disconnect();
          startGrid();
        }, { once: true, capture: true });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-strap-finder][data-section-id]').forEach(function (root) {
      init(root.getAttribute('data-section-id'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  /* init() no-ops on a section id that has no strap-finder root, so this can
     fire for every section the theme editor reloads. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail && e.detail.sectionId) init(e.detail.sectionId);
  });
})();
